import React, { useState, useEffect } from 'react';
import { S3Client, GetObjectCommand } from '@aws-sdk/client-s3';
import './DocumentPopup.css';
import { Modal } from 'react-bootstrap';

const DocumentPopup = ({
    id,
    type,
    document,
    onClose,
    displayMode = 'modal'
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [error, setError] = useState(null);
    const documentInfo = type === 'tilt'
        ? (document.tilt_document || '{}') : type === 'dialysis_doc'
            ? (document.dialysis_doc || '{}') : document.scale_document
                ? JSON.parse(document.scale_document || '{}')
                : {};

    const s3Client = new S3Client({
        region: 'ap-southeast-1',
        credentials: {
            accessKeyId: "Y0WWU13PSR9JMDUASN8V",
            secretAccessKey: "DF7tATk9SPB0aGkf8tzXkYcfHaBhl2BQzp3hRcm1",
        },
        endpoint: "https://s3.ap-southeast-1.wasabisys.com",
        forcePathStyle: true
    });

    useEffect(() => {
        const fetchPdfFromWasabi = async () => {
            if (!documentInfo.file_name) {
                alert.error('no document details found')
            } else {
                setIsLoading(true);
                setError(null);

                try {
                    const fileName = documentInfo.title;
                    const filePath = type === 'dialysis_doc' ? `Peace Village/patient/${id}/${type}/${fileName}`
                        : `Peace Village/patient/${id}/assessment_score/${type}/${fileName}`;

                    const command = new GetObjectCommand({
                        Bucket: "pvdev",
                        Key: filePath,
                    });

                    const response = await s3Client.send(command);
                    const chunks = [];
                    for await (const chunk of response.Body) {
                        chunks.push(chunk);
                    }
                    const blob = new Blob(chunks, { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(blob);
                    setPdfUrl(url);
                } catch (error) {
                    console.error('Failed to fetch PDF:', error);
                    setError('Failed to load PDF document');
                } finally {
                    setIsLoading(false);
                }
            }
        };

        fetchPdfFromWasabi();

        return () => {
            if (pdfUrl) {
                window.URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [documentInfo.file_name]);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Content to render (common for both modes)
    const renderContent = () => (
        <>
            <div className="document-details">
                {type === 'tilt' && <div className="detail-row">
                    <span className="detail-label">Assessment Type:</span>
                    <span className="detail-value" style={{ textTransform: 'capitalize' }}>{document.assessment_type || 'N/A'}</span>
                </div>}
                {(type !== 'tilt' && type !== 'dialysis_doc') && <div className="detail-row">
                    <span className="detail-label">Scale Type:</span>
                    <span className="detail-value">{document.score_scale === 'ss_scale' ? 'Scandinavian score scale' :
                        document.score_scale === 'gg_scale' ? 'Glasgow' : ' ASIA score scale'}</span>
                </div>}
                {(type === 'ss_scale' || type === 'gg_scale') && <div className="detail-row">
                    <span className="detail-label">Total Score:</span>
                    <span className="detail-value">{document.total_score}</span>
                </div>}
                <div className="detail-row">
                    <span className="detail-label">Date & Time:</span>
                    <span className="detail-value">{formatDate(type === 'dialysis_doc' ? document.dialysis_run_date : document.created_at)}</span>
                </div>
                {type === 'dialysis_doc' && document.terminated_remarks && <div className="detail-row">
                    <span className="detail-label">Remarks on Termination:</span>
                    <span className="detail-value">{document.terminated_remarks}</span>
                </div>}
            </div>

            <div className="pdf-viewer">
                {isLoading && (
                    <div className="loading-state">
                        <p>Loading PDF...</p>
                    </div>
                )}
                {error && (
                    <div className="error-state">
                        <p>{error}</p>
                    </div>
                )}
                {pdfUrl && !isLoading && !error && (
                    <iframe
                        src={pdfUrl}
                        width="100%"
                        height="500px"
                        title="PDF Document"
                        style={{ border: 'none' }}
                    />
                )}
            </div>
        </>
    );

    if (displayMode === 'modal') {
        return (
            <Modal show={true} onHide={onClose} centered size="lg">
                <Modal.Header closeButton>
                    <label style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>
                        Assessment Document Details
                    </label>
                </Modal.Header>
                <Modal.Body style={{ textAlign: "left", display: 'flex', flexDirection: 'column' }}>
                    {renderContent()}
                </Modal.Body>
            </Modal>
        );
    }

    return (
        <div style={{ padding: "15px", textAlign: "left", display: 'flex', flexDirection: 'column' }}>
            {renderContent()}
        </div>
    );
};

export default DocumentPopup;